export default __webpack_public_path__ + "static/media/icons.79507198.svg";